'use strict';

const Analytics = require('./analytics');

// The thank-you location values differ on purpose per analytics spec and must not be unified:
// - Login specifies 'thank_you_page'
// - Registration specifies 'thankyou_page'
const LOGIN_LOCATION_THANK_YOU = 'thank_you_page';
const REGISTRATION_LOCATION_THANK_YOU = 'thankyou_page';
const DEFAULT_LOGIN_LOCATION = 'header';
const DEFAULT_REGISTRATION_LOCATION = 'subscription_form';
const REGISTRATION_LOCATION_STORAGE_KEY = 'locationRegistration';

const LOGIN_LOCATIONS = [
    { pages: ['checkout'], location: 'checkout_form' },
    { pages: ['login'], location: 'subscription_form' },
    { pages: ['wishlist'], location: 'wishlist' },
    { pages: ['confirmation', 'registrationcomplete'], location: LOGIN_LOCATION_THANK_YOU },
    { pages: ['myprofile'], location: 'my_account' },
    { pages: ['accountnewregistration'], location: 'registration' },
    { pages: ['shareyourexperience'], location: 'reviews_section' },
    { pages: ['cart'], location: 'cart' }
];

class AnalyticsAccount extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'AnalyticsAccount';
        super.init(globalContainer, helperContainer);

        this.prepareObservers();

        this.prepareObserversRegistration();
        this.prepareErrorObservers();

        if (this.helper.checkPage('registrationcomplete') || this.helper.checkPage('thankyoureg')) {
            this.pushUnifiedRegisterThankYouPage();
        }

        if (this.helper.checkPage('click.email-tezenis.com') || this.helper.checkPage('registrationcomplete')) {
            if ($('#socialRegistration').length > 0) {
                this.pushRegisterConfirmInteractionSocial();
            } else {
                this.pushRegisterConfirmInteraction();
            }
        } else {
            if ($('.notFoundPage').length === 0) {
                window.sessionStorage.removeItem('reloadState');
            }
        }
        if (this.helper.checkPage('newregistration')) {
            if ($('#socialRegistration').length > 0) {
                this.pushRegisterConfirmInteractionDoubleOptinSocial();
            } else {
                this.pushRegisterConfirmInteractionDoubleOptin();
            }
        } else {
            window.sessionStorage.removeItem('reloadStateDoubleOptin');
        }

        if (this.helper.checkPage('addressbook') || this.helper.checkPage('account')) {
            this.prepareAccountObservers();
        }
        this.prepareObserversSocialRegistration();
        this.prepareSavingCardObservers();
        this.prepareAccountNavigationObservers();
        this.prepareSaveToWalletObservers();
        this.prepareProfileEnrichObservers();
        this.prepareOrderAgainObservers();
    }

    getUnifiedRegFlowData () {
        return {
            regFlowPosition: localStorage.getItem('regFlowPositionRegistration') || '',
            typeOfAccount: localStorage.getItem('typeOfAccountRegistration') || ''
        };
    }

    clearUnifiedRegFlowData () {
        localStorage.removeItem('regFlowPositionRegistration');
        localStorage.removeItem('typeOfAccountRegistration');
        localStorage.removeItem('firingRegistrationStep4Unified');
        localStorage.removeItem(REGISTRATION_LOCATION_STORAGE_KEY);
    }

    isAnyPage (pages) {
        return pages.some(page => this.helper.checkPage(page));
    }

    getLoginLocation () {
        const match = LOGIN_LOCATIONS.find(entry => this.isAnyPage(entry.pages));
        return match ? match.location : DEFAULT_LOGIN_LOCATION;
    }

    isThankYouPage () {
        return this.isAnyPage(['confirmation', 'order-confirm', 'registrationcomplete']) ||
            $('.cc-thankYouPage, .cc-thankYouPage_unifiedLoyaltyRegistration').length > 0 ||
            $('.page').data('action') === 'Order-Confirm';
    }

    getStoredRegistrationLocation () {
        try {
            return localStorage.getItem(REGISTRATION_LOCATION_STORAGE_KEY);
        } catch (e) {
            return null;
        }
    }

    getWelcomeLanding () {
        if (this.helper.checkPage('welcome')) {
            const segments = window.location.pathname.split('/').filter(Boolean);
            return segments[segments.length - 1] || null;
        }
        return null;
    }

    getRegistrationLocation (forceRefresh = false) {
        if (!forceRefresh) {
            const storedLocation = this.getStoredRegistrationLocation();
            if (storedLocation) {
                return storedLocation;
            }
        }
        if (this.isThankYouPage()) {
            return REGISTRATION_LOCATION_THANK_YOU;
        }
        const welcomeLanding = this.getWelcomeLanding();
        if (welcomeLanding) {
            return welcomeLanding;
        }
        return DEFAULT_REGISTRATION_LOCATION;
    }

    pushUnifiedRegisterThankYouPage () {
        // The flag is consumed on first view, so a page reload doesn't re-fire the event
        if (localStorage.getItem('firingRegistrationStep4Unified') !== 'true') {
            return;
        }
        localStorage.removeItem('firingRegistrationStep4Unified');

        const regFlowData = this.getUnifiedRegFlowData();
        this.quickImpressionSender.pushRegisterConfirmInteraction(
            this.getRegistrationLocation(),
            'success',
            regFlowData.typeOfAccount,
            regFlowData.regFlowPosition
        );
    }

    pushRegisterConfirmInteraction () {
        if (window.sessionStorage.getItem('reloadState')) {
            return;
        }
        if (localStorage.getItem('firingRegistrationStep4') === 'true') {
            localStorage.setItem('firingRegistrationStep4', '');
        } else {
            return;
        }

        let location = localStorage.getItem('locationRegistration');
        localStorage.setItem('locationRegistration', '');

        this.quickImpressionSender.pushRegisterConfirmInteraction(location);
        window.sessionStorage.setItem('reloadState', true);
    }

    pushRegisterConfirmInteractionSocial () {
        if (window.sessionStorage.getItem('reloadState')) {
            return;
        }
        if (localStorage.getItem('firingRegistrationStep4Social') === 'true') {
            localStorage.setItem('firingRegistrationStep5Social', 'true');
            localStorage.setItem('firingRegistrationStep4Social', '');
        } else {
            return;
        }
        let socialName = '';
        if ($('#socialRegistration').length) {
            socialName = $('#socialRegistration').data('social-name');
        }
        let typeOfAccount = this.helper.getTypeOfAccount();
        let regFlowPosition = localStorage.getItem('regFlowPositionRegistration') || '';

        this.quickImpressionSender.pushSocialRegistrationThankYouInteraction(socialName, 'success', typeOfAccount, regFlowPosition);
        window.sessionStorage.setItem('reloadState', true);
    }

    pushRegisterConfirmInteractionDoubleOptin () {
        if (window.sessionStorage.getItem('reloadStateDoubleOptin')) {
            return;
        }
        if ($('.analytics-registration-confirm').length === 0) {
            return;
        }

        this.quickImpressionSender.pushRegisterConfirmInteraction(localStorage.getItem('locationRegistration'));
        window.sessionStorage.setItem('reloadStateDoubleOptin', true);
    }

    pushRegisterConfirmInteractionDoubleOptinSocial () {
        if (window.sessionStorage.getItem('reloadStateDoubleOptin')) {
            return;
        }
        if ($('.analytics-registration-confirm').length === 0) {
            return;
        }
        if (localStorage.getItem('firingRegistrationStep5Social') === 'true') {
            localStorage.setItem('firingRegistrationStep5Social', '');
        } else {
            return;
        }
        let socialName = '';
        if ($('#socialRegistration').length) {
            socialName = $('#socialRegistration').data('social-name');
        }
        let typeOfAccount = this.helper.getTypeOfAccount();
        let regFlowPosition = localStorage.getItem('regFlowPositionRegistration') || '';

        this.quickImpressionSender.pushSocialRegistrationConfirmInteraction(socialName, 'success', typeOfAccount, regFlowPosition);
        window.sessionStorage.setItem('reloadStateDoubleOptin', true);
    }

    prepareObservers () {
        var _self = this;

        $('body').on('customer:login', function (e, data) {
            let anyErrors = false;
            let rememberMe = data.rememberMe;
            let sessionExpired = data.sessionExpired;
            if (data.data) {
                if (data.data.error) {
                    anyErrors = true;
                }
                if (data.data.rememberMe) {
                    rememberMe = data.data.rememberMe;
                }
                if (data.data.sessionExpired) {
                    sessionExpired = data.data.sessionExpired;
                }
            }
            _self.quickImpressionSender.pushLoginInteraction(data.type, data.socialName || '', rememberMe, sessionExpired, _self.getLoginLocation(), anyErrors, data.regFlowPosition);
        });

        $('form.login').on('login:error', function (e, data) {
            if (data && data.analyticsError && data.analyticsError.length > 0) {
                data.analyticsError.forEach(function (err, index) {
                    _self.quickImpressionSender.pushLoginErrorMessage(err, 'login/step1' + data.analyticsErrorDesc[index].replace(/ /g, "_"));
                });
            }   
        });
        
        $('body').on('customer:social_email_already_used', function (data) {
            if (data) {
                _self.quickImpressionSender.pushLoginErrorMessage('Your_email_address_is_already_associated_with_a_social_media_profile', 'social_login/step1_password');
            }
        });

        $('body').on('customer:register, customer:registerFirst', function (e, data) {
            let anyErrors = false;
            if (data.data && data.data.error) {
                anyErrors = true;
            }
            let regLocation = _self.getRegistrationLocation(true);
            if (data.regFlowPosition) {
                localStorage.setItem('registrationMethod', 'registration');
                localStorage.setItem(REGISTRATION_LOCATION_STORAGE_KEY, regLocation);
                localStorage.setItem('regFlowPositionRegistration', data.regFlowPosition);
                _self.quickImpressionSender.pushRegisterInteraction(data.type, regLocation, anyErrors, data.regFlowPosition);
                return;
            }
            _self.clearUnifiedRegFlowData();
            localStorage.setItem('registrationMethod', 'registration');
            localStorage.setItem(REGISTRATION_LOCATION_STORAGE_KEY, regLocation);
            _self.quickImpressionSender.pushRegisterInteraction(data.type, regLocation, anyErrors);
        });

        $('body').on('customer:newsletterPreferencesSave', function (e, data) {
            var brandCodes = _self.helper.getFormatedNewsletterPreferenceBrands(data.brands);
            _self.quickImpressionSender.pushNewsletterPreferenceSave(
                data.direktMarketingAgreement,
                data.profilingAgreement,
                brandCodes
            );
        });

        $('body').on('analytics:prepareLoyaltySubscription', function (e) {
            _self.quickImpressionSender.pushThankyouRegisterLoyalty(_self.helperData.userId);
        });

        // Social Login / Registration
        $('body').on('customer:socialLogin', function (e, data) {
            let anyErrors = false;
            if (data && data.error && data.error.length) {
                anyErrors = true;
            }
            _self.quickImpressionSender.pushLoginInteraction(data.type, data.socialName || '', data.rememberMe, data.sessionExpired, _self.getLoginLocation(), anyErrors, data.regFlowPosition);
        });

        // Persistent Login / tooltip
        $('body').on('customer:persistentTooltip', function (e, data) {
            _self.quickImpressionSender.pushPersistentLoginTooltipInteraction();
        });

        $('body').on('customer:ratingAndReviewsTabsAction', function (e, topic) {
            _self.quickImpressionSender.pushRatingAndReviewsTabsInteraction(_self.helper.formatNameForAnalytics(topic));
        });

        $('body').on('analytics:otpRegisterConfirm', function (e) {
            _self.quickImpressionSender.pushRegisterConfirmInteractionDoubleOptin();
        });

        $('body').on('analytics:registerConfirmOptin', function (e, data) {
            if (data.regFlowPosition) {
                if (!data.error) {
                    _self.clearUnifiedRegFlowData();
                }
                _self.quickImpressionSender.pushRegisterConfirmInteractionDoubleOptin(data.error ? 'error' : 'success', data.typeOfAccount, data.regFlowPosition);
                return;
            }
            _self.pushRegisterConfirmInteractionDoubleOptin();
        });
    }

    prepareErrorObservers () {
        var _self = this;

        $('body').on('customer:account_error', function (e, data) {
            let socialFirstStepMail = localStorage.getItem('socialFirstStepMail');
            if (data && data.type && data.type.indexOf('social') !== -1) {
                if (data.step == 'step2_phone' && (!socialFirstStepMail || socialFirstStepMail == '')) {
                    data.step = 'step1_phone';
                }
            }
            if ($('.page').data('action') !== 'Account-Show') {
                _self.quickImpressionSender.pushLoginOrRegistrationError(data.type, data.step, data.errorMsg);
            }
        });

        $('body').on('customer:social_email_already_used', function (e, data) {
            _self.quickImpressionSender.pushSocialRegistrationStep1Interaction(data.type, data.socialName, data.errorMsg);
        });
    }

    prepareAccountObservers () {
        var _self = this;
        var lastAction = '';

        $('.js-edit-address').on('click', function () {
            lastAction = 'change';
            _self.quickImpressionSender.pushUpdateAddress('change');
        });

        $('.js-add-address').on('click', function () {
            lastAction = 'new_address';
            _self.quickImpressionSender.pushUpdateAddress('new_address');
        });

        $('body').on('address:submit', function (e) {
            _self.quickImpressionSender.pushSaveUpdateAddress(lastAction);
        });
    }

    prepareSavingCardObservers () {
        var _self = this;

        $('body').on('click', '.add-new-cc-link', function (e) {
            let location = 'my_account';
            if ($(e.currentTarget).closest('.cc-drawer').length !== 0) {
                location = 'checkout';
            }
            _self.quickImpressionSender.pushAddCreditCard(location);
        });

        $('body').on('click', '.cc-drawer .submit-payment', function () {
            if ($('#saveCreditCard').is(':checked:visible')) {
                _self.quickImpressionSender.pushSaveCreditCard('checkout');
            }
        });

        $('body').on('account:savingCard', function () {
            _self.quickImpressionSender.pushSaveCreditCard('my_account');
        });

        $('body').on('account:removingCard', function () {
            _self.quickImpressionSender.pushUpdateCreditCard('delete_credit_card');
        });

        $('body').on('click', '.edit-payment', function () {
            _self.quickImpressionSender.pushUpdateCreditCard('change_credit_card');
        });
    }

    /**
     * NEW REG FLOW - Step 3 (personal data).
     * Unlike the legacy flow, step 4 is NOT pushed here: it's pushed when the thank you step is really shown
     * (customer:registerThankYouPage in modal, thank you page load on landing page).
     * @param {Object} data - trigger data from unifiedRegistration.js
     * @param {boolean} anyErrors - step result
     */
    handleUnifiedRegisterThird (data, anyErrors) {
        const typeOfAccount = data.typeOfAccount || this.helper.getTypeOfAccount();
        const location = this.getRegistrationLocation();

        if (data.isSocial) {
            this.quickImpressionSender.pushSocialRegistrationStep3Interaction(typeOfAccount, this.getSocialName(data.socialName), anyErrors, data.rememberMe, data.regFlowPosition);
            if (!anyErrors && typeOfAccount === 'profile_loyalty') {
                $('body').trigger('customer:registerLoyalty', 'profile_loyalty');
            }
            return;
        }

        this.quickImpressionSender.pushRegisterInteractionPersonalData(typeOfAccount, anyErrors, location, data.rememberMe, data.regFlowPosition, data.privacyNews, data.privacyCustomNews);

        if (anyErrors) {
            return;
        }

        if (typeOfAccount === 'profile_loyalty') {
            $('body').trigger('customer:registerLoyalty', 'profile_loyalty');
        }

        localStorage.setItem('regFlowPositionRegistration', data.regFlowPosition);
        localStorage.setItem('typeOfAccountRegistration', typeOfAccount);
        if (data.thankYouPageOnLoad) {
            localStorage.setItem('firingRegistrationStep4Unified', 'true');
        }
    }

    getCtaRegFlowPosition ($button) {
        if ($button.is('.js-login-popup')) {
            return 'modal';
        }
        if ($button.is('.js-layer-login, .cartCustomerNotAuthenticated') && $('body').attr('data-layer-login-disabled') !== 'true') {
            return 'modal';
        }
        let href = $button.attr('href') || '';
        if (href && href !== '#' && href.indexOf('mailto:') !== 0 && href.indexOf('javascript:') !== 0) {
            return 'landing_page';
        }
        return $('.js-unified-page-wrapper').length ? 'landing_page' : 'modal';
    }

    getSocialName (providerName) {
        return localStorage.getItem('socialNameRegistration') || providerName || '';
    }

    prepareObserversRegistration () {
        var _self = this;

        $('body').on('click', '.analytics-login-register-button, .analytics-content-button', function (e) {
            let action = _self.helper.formatString($(e.currentTarget).data('action'));
            let location = _self.helper.formatString($(e.currentTarget).data('location'));
            let regFlowPosition = _self.getCtaRegFlowPosition($(e.currentTarget));
            _self.quickImpressionSender.pushActionsOnTheBottomsInteraction(action, location, regFlowPosition);
        });

        $('body').on('click', '.login-popup-footer button', function (e) {
            _self.quickImpressionSender.pushActionsOnTheBottomsInteraction('register', 'log_in_your_account_modal', 'modal');
        });

        // Registration - Step 2: telephone
        $('body').on('customer:registerSecond', function (e, data) {
            let anyErrors = false;
            if (data.data && data.data.error) {
                anyErrors = true;
            }
            if (data.regFlowPosition) {
                if (data.isSocial) {
                    _self.quickImpressionSender.pushSocialRegistrationStep1Interaction('phone', _self.getSocialName(data.socialName), anyErrors, data.regFlowPosition);
                    return;
                }
                _self.quickImpressionSender.pushRegisterInteractionTelephone(anyErrors, data.regFlowPosition);
                return;
            }
            if ($('.page').data('action') === 'Account-Show' && anyErrors) {
                return;
            }
            _self.quickImpressionSender.pushRegisterInteractionTelephone(anyErrors);
        });

        // Registration - Step 3: Personal Data
        $('body').on('customer:registerThird', function (e, data) {
            let anyErrors = false;
            let analyticsMode = '';

            let privacyNews = (data && typeof data.privacyNews === 'boolean')
                ? data.privacyNews
                : ($('.js-add-to-email-toggle:checked, #add-to-email-list-yes:checked, .newspromotion:checked').length > 0);

            let privacyCustomNews = (data && typeof data.privacyCustomNews === 'boolean')
                ? data.privacyCustomNews
                : ($('.js-add-to-personalized-toggle:checked, #add-to-personalized-news-list-yes:checked, .personalizednews:checked').length > 0);

            data.privacyNews = privacyNews;
            data.privacyCustomNews = privacyCustomNews;

            if (data.data && data.data.error) {
                anyErrors = true;
            }

            if (data.regFlowPosition) {
                _self.handleUnifiedRegisterThird(data, anyErrors);
                return;
            }

            let location = localStorage.getItem(REGISTRATION_LOCATION_STORAGE_KEY) || _self.getRegistrationLocation();

            if (!anyErrors) {
                _self.quickImpressionSender.pushRegisterConfirmInteraction(location);
                localStorage.setItem('firingRegistrationStep4', 'true');
            }

            if (($('.loyaltyFlag:checked').length === 1 || $('.loyalty-flag:checked').length === 1) && !anyErrors) {
                analyticsMode = 'profile_loyalty';
            }

            if (data.analyticsMode) {
                analyticsMode = data.analyticsMode;
            }

            _self.quickImpressionSender.pushRegisterInteractionPersonalData(analyticsMode, anyErrors, location, data.rememberMe, undefined, data.privacyNews, data.privacyCustomNews);
        });

        $('body').on('customer:registerThankYouPage', function (e, data) {
            _self.quickImpressionSender.pushRegisterConfirmInteraction(
                _self.getRegistrationLocation(),
                'success',
                data.typeOfAccount,
                data.regFlowPosition
            );
        });

        // Loyalty Card Subscription
        $('body').on('customer:registerLoyalty', function (e, data) {
            let analyticsMode = typeof data === 'string' ? data : (data && data.analyticsMode ? data.analyticsMode : '');
            _self.quickImpressionSender.pushRegisterInteractionLoyaltyRegistration(analyticsMode);
        });
    }

    prepareObserversSocialRegistration () {
        var _self = this;

        $('body').on('customer:socialRegistration', function (e, data) {
            let socialName = _self.helper.formatNameForAnalytics(data && data.socialName);
            _self.quickImpressionSender.pushSocialRegistrationInteraction(socialName || '');
        });

        $('body').on('click', '.socialLoginContainer button', function (e) {
            let socialName = _self.helper.formatNameForAnalytics($(e.currentTarget).attr('title'));
            let regFlowPosition;
            if ($(e.currentTarget).closest('#unified-login-form').length) {
                regFlowPosition = $('.js-unified-page-wrapper').length ? 'landing_page' : 'modal';
            }
            localStorage.setItem('socialNameRegistration', socialName || '');
            _self.quickImpressionSender.pushSocialRegistrationInteraction(socialName || '', regFlowPosition);
        });

        $('body').on('customer:registerSocialFirst', function (e, data) {
            let anyErrors = false;
            if (data && data.data && data.data.error && data.data.error.length) {
                anyErrors = true;
            }
            let socialName = '';
            if ($('#socialRegistration').length) {
                socialName = $('#socialRegistration').data('social-name');
            }
            if (!anyErrors) {
                localStorage.setItem('socialFirstStepMail', 'true');
            }
            _self.quickImpressionSender.pushSocialRegistrationStep1Interaction('email', socialName, anyErrors);
        });

        $('body').on('customer:registerSocialSecond', function (e, data) {
            let anyErrors = false;
            if (data && data.data && data.data.error && data.data.error.length) {
                anyErrors = true;
            }
            let socialName = '';
            if ($('#socialRegistration').length) {
                socialName = $('#socialRegistration').data('social-name');
            }
            let socialFirstStepMail = localStorage.getItem('socialFirstStepMail');
            if (!socialFirstStepMail || socialFirstStepMail == '') {
                _self.quickImpressionSender.pushSocialRegistrationStep1Interaction('phone', socialName, anyErrors);
            } else {
                _self.quickImpressionSender.pushSocialRegistrationStep2Interaction('phone', socialName, anyErrors);
            }
        });

        $('body').on('customer:registerSocialThird', function (e, data) {
            let anyErrors = false;
            let analyticsMode = 'only_social_registration';
            if (data && data.data && data.data.error && data.data.error.length) {
                anyErrors = true;
            }
            let socialName = '';
            if ($('#socialRegistration').length) {
                socialName = $('#socialRegistration').data('social-name');
            }
            if ($('.loyaltyFlag:checked').length === 1 && !anyErrors) {
                analyticsMode = 'social_profile_loyalty';
                $('body').trigger('customer:registerLoyalty', 'profile_loyalty');
            }
            if (!anyErrors) {
                localStorage.setItem('firingRegistrationStep4Social', 'true');
            }
            _self.quickImpressionSender.pushSocialRegistrationStep3Interaction(analyticsMode, socialName, anyErrors, data.rememberMe);
        });

        document.addEventListener('click', function (e) {
            if (e.target && e.target.closest && e.target.closest('.js-account-delete-button, .js-account-delete-persistent-button, .js-unified-account-delete-button')) {
                _self.quickImpressionSender.pushDeleteAccount();
            }
        }, true);

        $('body').on('analytics:accountRemoveConfirmation', function (e) {
            _self.quickImpressionSender.pushDeleteAccountSuccess();
        });
    }

    prepareAccountNavigationObservers () {
        var _self = this;

        $('.analytics-menu-items').on('click', function (e) {
            let voice = ($(this).data('analytic-name'));
            _self.quickImpressionSender.pushNavigationRelatedToMyAccount(voice);
        });

        $('.account-menu-link').on('click', function (e) {
            let voice = ($(this).data('analytic-name'));
            _self.quickImpressionSender.pushNavigationRelatedToMyAccount(voice);
        });

        $('body').on('click', '.js-talent-menu-link', function () {
            let action = $(this).data('action');
            $('body').trigger('analytics:talentMenu', { action: action });
        });
    }

    prepareSaveToWalletObservers () {
        var _self = this;

        $('body').on('analytics:saveGoogleWalletCard', function (e, data) {
            _self.quickImpressionSender.pushSaveToWallet('google_pay');
        });
        $('body').on('analytics:saveAppleWalletCard', function (e, data) {
            _self.quickImpressionSender.pushSaveToWallet('apple');
        });
        $('body').on('analytics:couponUsingType', function (e, data) {
            _self.quickImpressionSender.pushCouponUsingType(data.action, data.coupon, data.label);
        });
        $('body').on('analytics:experienceCoupon', function (e, data) {
            _self.quickImpressionSender.pushExperienceCoupon(data.action, data.label);
        });
        $('body').on('analytics:missionStart', function (e, data) {
            _self.quickImpressionSender.pushMissionStart(data.missionName, data.points, data.section, data.missionId);
        });
        $('body').on('analytics:missionAction', function (e, data) {
            _self.quickImpressionSender.pushMissionAction(data.missionName, data.points, data.action, data.missionId);
        });
        $('body').on('analytics:missionComplete', function (e, data) {
            _self.quickImpressionSender.pushMissionComplete(data.missionName, data.points, data.missionId);
        });
        $('body').on('analytics:unsubscribeTalentStep1', function () {
            _self.quickImpressionSender.pushUnsubscribeTalentStep1();
        });
        $('body').on('analytics:unsubscribeTalentConfirmation', function () {
            _self.quickImpressionSender.pushUnsubscribeTalentConfirmation();
        });
        $('body').on('analytics:talentCard', function () {
            _self.quickImpressionSender.pushTalentCardInteraction();
        });
        $('body').on('analytics:talentCoupon', function () {
            _self.quickImpressionSender.pushTalentCouponInteraction();
        });
        $('body').on('analytics:talentMenu', function (e, data) {
            _self.quickImpressionSender.pushTalentMenuInteraction(data.action);
        });
        $('body').on('analytics:gameAction', function (e, data) {
            _self.quickImpressionSender.pushGameAction(data.gameName, data.points, data.gameId);
        });
        $('body').on('analytics:gameComplete', function (e, data) {
            _self.quickImpressionSender.pushGameComplete(data.gameName, data.points, data.gameId, data.action);
        });
    }

    prepareProfileEnrichObservers () {
        var _self = this;

        function getTopic (step) {
            let stepMap = {
                'step_1': 'fav_collection',
                'step_2': 'fav_products',
                'step_3': 'fav_materials',
                'step_4': 'buy_for',
                'step_4-1': 'buy_for-age_group',
                'step_5': 'fav_shop',
                'step_6': 'interests'
            };
            let topic = stepMap[step];
            if (topic) {
                return topic;
            }
            return 'other';
        }

        $('body').on('click', '.analytics-enrich-btn', function () {
            _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnly();
        });

        $('body').on('analytics:profileEnrich', function (e, data) {
            let step = data.step;
            let preferences = data.preferences;
            var descriptionPreferences = [];
            let amountOfPreferences = preferences.length;
            preferences = preferences.join('+').toLowerCase();

            for (let i = 0; i < amountOfPreferences; i++) {
                let tempPreferences = [];
                let tempPreferences4Letters = [];
                tempPreferences.push(preferences.split('+'));
                tempPreferences[0][i] = tempPreferences[0][i].replace('-', '_');

                if ((/\s/).test(tempPreferences[0][i])) {
                    var checkForSpaces = tempPreferences[0][i].replace(/ /g, '_');
                    checkForSpaces = checkForSpaces.split('_');

                    for (let j = 0; j < checkForSpaces.length; j++) {
                        tempPreferences4Letters.push(checkForSpaces[j].slice(0, 4));
                    }
                    tempPreferences4Letters = tempPreferences4Letters.join('_');
                } else {
                    tempPreferences4Letters = tempPreferences[0][i].slice(0, 4);
                }

                descriptionPreferences.push(tempPreferences4Letters);
            }
            descriptionPreferences = descriptionPreferences.join('-');
            descriptionPreferences = descriptionPreferences.replace(/ /g, '_');
            switch (step) {
            case 'step_1':
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep01((getTopic(step)), descriptionPreferences);
                break;
            case 'step_2':
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep02((getTopic(step)), descriptionPreferences);
                break;
            case 'step_3':
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep03((getTopic(step)), descriptionPreferences);
                break;
            case 'step_4':
                let step4 = $('.step-container.step_4').find('.js-children-number').hasClass('hidden') ? 'step_4' : 'step_4-1';
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep04((getTopic(step4)), descriptionPreferences);
                break;
            case 'step_5':
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep05((getTopic(step)), descriptionPreferences);
                break;
            case 'step_6':
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep06((getTopic(step)), descriptionPreferences);
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyFinished();
                break;
            }
        });

        $('body').on('click', '.analytics-proceed-exit', function (e, data) {
            var $mappingContainer = $('.mapping-container');
            var currentStep = $mappingContainer.attr('data-step');

            _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyLeavingSurvey(getTopic(currentStep));
        });
    }

    prepareOrderAgainObservers () {
        const _self = this;

        $('body').on('analytics:orderHistoryUpdate', (_e, data) => {
            let ctaName = data.ctaName;
            if (ctaName) {
                _self.quickImpressionSender.pushMyOrdersAndReturns(ctaName);
            }
        });

        $('body').on('click', '.analytics-orderAgain-viewAll', () => {
            _self.quickImpressionSender.pushMyOrdersAndReturns('see_all_past_orders');
        });

        $('body').on('click', '.analytics-orderAgain-item', (e) => {
            const isCart = _self.helper.checkPage('cart');
            let ctaAction = $(e.currentTarget).data('analytics-action');
            let sku = $(e.currentTarget).closest('.cc-orderAgain-page__productCard').length
                ? $(e.currentTarget).closest('.cc-orderAgain-page__productCard').data('analytics-sku')
                : $(e.currentTarget).closest('.cc-orderAgain-page__buttonContainer').data('analytics-sku');

            if (ctaAction && sku) {
                _self.quickImpressionSender.pushBuyItAgain(
                    isCart ? 'cart' : 'my_orders_and_returns',
                    ctaAction,
                    _self.helper.getFormatSku(sku)
                );
            }
        });

        $('body').on('click', '.analytics-orderAgain-orderDetails', (e) => {
            const $currentTarget = $(e.currentTarget);
            const isCart = _self.helper.checkPage('cart');
            const area = isCart ? 'cart' : 'my_orders_and_returns';
            const text = $currentTarget.data('analytics-type') || 'buy_it_again';
            const sku = $currentTarget.data('analytics-pid');

            if (sku) {
                _self.quickImpressionSender.pushBuyItAgain(
                    area,
                    text,
                    _self.helper.getFormatSku(sku)
                );
            }
        });
    }
}

const obj = new AnalyticsAccount();
module.exports = obj;
